import { el } from './dom.js';
import { propertyPath } from '../data/url.js';

/** 物件の種類を、見る人に分かる言葉にする */
const KIND_LABEL = Object.freeze({
  model: '3D（歩ける）',
  scan: '3D（歩ける）',
  photo: '写真',
  none: '準備中',
});

/**
 * トップページ（/）の物件一覧。
 * 「このURLを社内やお客様に渡せば、どの物件も選べる」状態にするための入口。
 */
export function createPropertyIndex(container, { properties, notice = null, search = '' }) {
  const cards = properties.map((property) => {
    const ready = property.ready !== false;
    const kind = el('span', { class: 'px-kind' }, KIND_LABEL[property.kind] ?? '準備中');
    const body = [
      el('span', { class: 'px-name' }, property.name),
      property.address ? el('span', { class: 'px-address' }, property.address) : null,
      kind,
    ].filter((node) => node !== null);

    if (!ready) {
      return el('div', { class: 'px-card is-pending' }, [...body, el('span', { class: 'px-note' }, '準備中')]);
    }
    return el('a', { class: 'px-card', href: propertyPath(property.id, search) }, body);
  });

  const root = el('div', { class: 'px' }, [
    el('header', { class: 'px-head' }, [
      el('h1', { class: 'px-title' }, 'AI内見'),
      el('p', { class: 'px-lead' }, '見たい物件を選んでください。3Dの物件は中を歩いて回れます。'),
    ]),
    notice === null ? null : el('p', { class: 'px-notice' }, notice),
    cards.length === 0 ? el('p', { class: 'px-empty' }, '公開中の物件がありません。') : el('div', { class: 'px-list' }, cards),
  ].filter((node) => node !== null));

  container.appendChild(root);
  return { root };
}
